/*
 * @Description:
 * @Author: TechAhead
 * @Date: 2019-11-20 12:03:51
 * @LastEditTime: 2019-11-20 15:40:47
 */
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: `http://${domain}/v1/web`,
  // apiUrl: `http://10.11.5.168:7071/api`
  apiUrl: `https://auth.contractorprojectmanagement.com/api`,
  superadmin_url: `https://auth.contractorprojectmanagement.com/api/superadmin`,
  endPoint: `/superadmin`
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
